import React, { useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import DateSelect from "components/bootstrap/DateSelect/DateSelect";
import SubTitle from "components/SubTitle";
import { useTranslation } from "react-i18next";
import { convertISOtoDMYHM } from "common/helpers/convertISO";
import { handleSelectChange } from "components/Reports/ReportsStats/helper";
import { useGetReversedDecisionsQuery } from "features/api/reports/reportsSlice";
import { DecisionsTypeArray } from "components/Reports/reportAssets/assets";
import { tDecisionType } from "i18n/enums";
import { columns } from "./columns";

type ReversedDecisionModalBodyProps = {
  selectedDatePeriod: string;
  startDateString;
  userId;
};
const ReversedDecisionModalBody = ({
  selectedDatePeriod,
  startDateString: initialStartDate,
  userId,
}: ReversedDecisionModalBodyProps) => {
  const { t } = useTranslation();
  const [startDateString, setStartDateString] = useState(initialStartDate);

  const [selectedDatePeriodModal, setSelectedDatePeriodModal] =
    useState(selectedDatePeriod);

  const endDateString = useMemo(() => {
    const date = new Date();
    date.setUTCHours(23, 59, 59, 999);
    return date.toISOString();
  }, []);

  const { data: reversedDecisions, isLoading } = useGetReversedDecisionsQuery({
    start: startDateString ?? startDateString,
    end: endDateString ?? endDateString,
    userId,
  });

  const convertDecisionToString = (decision: number) => {
    // D-08: localize the finite decision-type enum (matched by stable code) via
    // the lookup helper; return null when the code is not a known decision type.
    const match = DecisionsTypeArray.find((item) => item.code === decision);
    return match ? tDecisionType(decision) : null;
  };
  const reversedData = reversedDecisions?.map((item) => ({
    ...item,
    reportCreationTime: convertISOtoDMYHM(item.reportCreationTime),
    firstDecision: convertDecisionToString(item.firstDecision),
    lastDecision: convertDecisionToString(item.lastDecision),
  }));

  return (
    <>
      <div className="title-and-date">
        <SubTitle className="sub-title-bold">{t("reversedReports")}</SubTitle>
        <DateSelect
          noBorder
          className="fitContent"
          value={selectedDatePeriodModal}
          onChange={(e) => {
            setSelectedDatePeriodModal(e.target.value);
            handleSelectChange({
              e,
              setStartDate: setStartDateString,
              isNeedToConverdDateFormat: true,
            });
          }}
        />
      </div>

      {`${reversedData?.length} ${t("reports")}`}
      {isLoading ? (
        "Loading..."
      ) : (
        <BootstrapTable
          striped
          wrapperClasses="reversed-table"
          bordered={false}
          bootstrap4
          keyField="id"
          data={reversedData}
          columns={columns}
          defaultSorted={[
            {
              dataField: "reportCreationTime",
              order: "desc",
            },
          ]}
        />
      )}
    </>
  );
};

export default ReversedDecisionModalBody;
